import React from "react"

import HeaderAppTitle from "../../common/app-title/app-title"
import {ICONS} from "../../../../../core/gd/const/icons/icons"

type Props = {
    projectCollectionId: ID
}

export default class PortfolioTitle extends React.Component<Props> {

    onBlur = (newValue: string) => {
        if (!newValue || newValue.trim() === "") return

        const projectCollection = gd.session.projectCollections.get(this.props.projectCollectionId)
        if (projectCollection) {
            projectCollection.name = newValue
            projectCollection.save()
        }

        this.forceUpdate()
    }

    render() {
        const projectCollection = gd.session.projectCollections.get(this.props.projectCollectionId)!
        const isEditable = (gd.projectCollectionViews.currentView && gd.projectCollectionViews.currentView.availableActions.canRename) || false

        const classes = Classes("gd-ui-project-icon app-header-type", ICONS.PORTFOLIO)

        return (
            <>
                <div className={classes}/>
                <HeaderAppTitle name        = {projectCollection.name}
                                editable    = {isEditable}
                                onChange    = {this.onBlur} />
            </>
        )
    }
}